import { useEffect, useState } from 'react';

import FarmsGrid from 'components/FarmsGrid';
import Page from 'components/Page';

import useFarms from 'hooks/useFarms';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const FarmsPage: FunctionComponent<Props> = ({ testId = TEST_ID }) => {
    const { farms = [], fetch } = useFarms();
    const [hasMore, setHasMore] = useState(false);

    useEffect(() => {
        (async () => {
            const { done } = await fetch().next();

            setHasMore(!done);
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleNext = async () => await fetch().next();

    return (
        <Page className={styles.farmsPage} testId={testId}>
            <FarmsGrid onNext={hasMore ? handleNext : undefined} rows={farms} />
        </Page>
    );
};

export default FarmsPage;
